import { callOnce } from '../utils/initialize';

const TAB_FOCUS = 'TAB_FOCUS';
const RANDOM_CLICK = 'RANDOM_CLICK';

const events = [TAB_FOCUS, RANDOM_CLICK];

const initializeEventListeners = () => {
  EVENT_BUS.registerEvents(events);
};

const listenToVisibilityChange = () => {
  document.addEventListener(
    'visibilitychange',
    () => {
      if (!document.hidden) {
        EVENT_BUS.dispatch(TAB_FOCUS);
      }
    },
    false
  );
};

const listenToGlobalRandomClick = () => {
  document.addEventListener(
    'click',
    ($event) => {
      const { target } = $event
      EVENT_BUS.dispatch(RANDOM_CLICK, { target });
    }
  )
}

callOnce(listenToVisibilityChange);
callOnce(listenToGlobalRandomClick);

export const WINDOW_EVENTS = {
  TAB_FOCUS,
  RANDOM_CLICK,
  initializeEventListeners,
};
